export const getEventCategoryOptions = (catalog, current = 'general') => {
    const seen = new Set();
    const options = (Array.isArray(catalog) ? catalog : []).flatMap(category => {
        if (typeof category?.id !== 'string' || !/^[a-z][a-z0-9_-]{0,19}$/.test(category.id) || seen.has(category.id)) return [];
        seen.add(category.id);
        const label = typeof category.labels?.cat === 'string' && category.labels.cat.trim()
            ? category.labels.cat : category.id;
        return [{ value: category.id, label }];
    });
    // An older/offline catalogue must never display an unknown assignment as General.
    if (typeof current === 'string' && current && !seen.has(current)) {
        options.push({ value: current, label: current === 'general' ? 'General' : current });
    }
    return options;
};
